module.exports = __webpack_public_path__ + "images/84320848a91d9e86c4d9b20769efbb59.jpg";


//////////////////
// WEBPACK FOOTER
// ./webpack/assets/img/diaryofanant-characters03.jpg
// module id = ./webpack/assets/img/diaryofanant-characters03.jpg
// module chunks = 0